import React from 'react';
import { object, func, string } from 'prop-types';
import classNames from 'classnames';
import { getContext } from '@fiverr-private/fiverr_context';
import { Button } from '@fiverr-private/fit';
import { redirectToInboxConversation } from '../utils';
import { JS_JOIN_HOOK } from '../../../../utils/constants';
import { isLoggedInUser } from '../../../../utils/isLoggedInUser';
import { FirstMessagePopup } from '..';

const Trigger = (
    { onClick, onSubmitSuccess, className, children },
    { pathfinderWrapper, general }
) => {
    const handleClick = (openModal) => {
        const { isMobile } = getContext();

        onClick();

        if (!isLoggedInUser()) {return;}

        isMobile? redirect() : openModal();
    };

    const redirect = () => {
        redirectToInboxConversation(pathfinderWrapper);
    };

    const buttonClassNames = classNames(
        className,
        { [JS_JOIN_HOOK]: !isLoggedInUser() }
    );

    const buttonProps = () => ({
        className: buttonClassNames,
        color: general.isPro ? Button.COLORS.BLACK : Button.COLORS.GREY,
        fill: Button.FILLS.GHOST
    });

    return (
        <FirstMessagePopup onSubmitSuccess={onSubmitSuccess} trigger={({ open }) => (
            <Button {...buttonProps()}
                onClick={() => handleClick(open)}>
                {children}
            </Button>
        )}/>
    );
};

Trigger.propTypes = {
    onClick: func.isRequired,
    onSubmitSuccess: func,
    className: string,
    children: func
};

Trigger.contextTypes = {
    pathfinderWrapper: object,
    general: object
};

export default Trigger;
